<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="contact"
        :content="header"
      />
    </template>
    <template slot="main">
      <DetalleAdministrativeCentreFaceB2B v-if="SendType && !loading" ref="adminFace" :form="form"/>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isRoleUserConsultaProvider"
            mode="primary"
            :text="$t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { i18n } from '@/i18n'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import DetalleAdministrativeCentreFaceB2B from '@/components/DetalleAdministrativeCentreFaceB2B.vue'

import { getAdministrativeCenterFB2B } from '@/services/configurations/getAdministrativeCenterFB2B'
import { addAdministrativeCenterFB2B } from '@/services/configurations/addAdministrativeCenterFB2B'
import { updateAdministrativeCenterFB2B } from '@/services/configurations/updateAdministrativeCenterFB2B'

import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

export default {
  /* eslint-disable camelcase */
  name: 'detail-administrative-center-fb2b',
  components: {
    DetailLayout,
    DetalleAdministrativeCentreFaceB2B
  },
  props: {
    SendType: {
      type: [String, Boolean],
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      distribuidores: [],
      header: {
        title: i18n.t('administrativecenter.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'masters/society/locations/administrativecenters',
        params: { issuingCreation: false }
      },
      loadedFirstTime: false,
      form: this.getDefaultForm(),
      clientes: [],
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
    issuingType: function () {
      return this.$store.getters['invoicesIssuing/issuingType']
    },
    isSocietyCreation: function () {
      return !!this.$store.getters['app/isInMode'](2)
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idSede: function () {
      return parseInt(this.$route.params.idSede)
    },
    idCAdminFB2B: function () {
      return parseInt(this.$route.params.idCentro)
    },
    isCreate: function () {
      return this.idCAdminFB2B === -1
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
  },
  created: async function () {
    if (this.SendType && !this.loading) {
      const breadcrumbs = []
      if (this.isIssuingCreation) {
        this.header.params.issuingCreation = true
        const issuingBreadcrumb = {
          path: 'invoicesissuing',
          name: i18n.t('invoices.invoices_issuing.header_long'),
          params: { issuingCreation: true, issuingType: this.issuingType }
        }
        if (this.issuingType === 2) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.proforma.header_long')
        else if (this.issuingType === 3) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.quotation.header_long')
        breadcrumbs.push(issuingBreadcrumb)
        breadcrumbs.push({
          path: 'masters/society/locations/administrativecenters',
          name: i18n.t('administrativecenter.header'),
          params: { issuingCreation: true }
        })
      } else {
        breadcrumbs.push({ path: 'masters', name: i18n.t('masters.header') })
        breadcrumbs.push({ path: 'masters/society', name: i18n.t('agenda.sociedad') })
        if (!this.isSocietyCreation) {
          breadcrumbs.push({ path: 'masters/society/locations', name: i18n.t('sedes.header') })
          breadcrumbs.push({ path: 'masters/society/locations/administrativecenters', name: i18n.t('administrativecenter.header') })
        }
      }
      
      if (!this.isCreate) {
        await this.downloadData(this.idCAdminFB2B)
        breadcrumbs.push({ path: '', name: this.form.Code })
        this.$store.commit('app/setheaderBreadCrumb', this.form.Code)
      } else {
        this.$route.params.idCentro = -1
        breadcrumbs.push({
          path: '',
          name: i18n.t('administrativecenter.new')
        })
      }
      this.header.breadcrumb = breadcrumbs
    }
  },
  mounted () {
  },
  methods: {
    getDefaultForm: function () {
      return {
        Code: '',
        Name: '',
        Role: '',
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs.adminFace.validate(valid => {
        if (valid) {
          const params = {
            IdSociedad: this.id,
            IdSede: this.idSede,
            Code: this.form.Code,
            Name: this.form.Name,
            Role: this.form.Role,
          }
          if (this.isCreate) {
            this.newAdministrativeCenterFB2BHandler(params)
          } else {
            this.updateAdministrativeCenterFB2BHandler(params)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
          this.$store.commit('setIsLoading', false)
        }
      })
    },
    resetForm: async function () {
      if (this.$refs.adminFace) {
        this.$refs.adminFace.getDefaultForm()
      }
    },
    newAdministrativeCenterFB2BHandler: async function (params) {
      const response = await addAdministrativeCenterFB2B(params)
      if (response.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      } else {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.goBack()
        this.form = this.getDefaultForm()
      }
  
      this.$store.commit('setIsLoading', false)
    },
    updateAdministrativeCenterFB2BHandler: async function (params) {
      const data = {
        ...params,
        IdAdministrativeCentreFACeB2B: this.idCAdminFB2B
      }
      const response = await updateAdministrativeCenterFB2B(data)
      if (response.blnError === false) {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.updateView()
        this.goBack()
      } else {
        this.doFeedback(response.msgError)
      }
      
      this.$store.commit('setIsLoading', false)
    },
    goBack: function () {
      setTransitionAllowed(1, this.isIssuingCreation)
      setTransitionAllowed(2, this.isSocietyCreation)
      this.$router.push({ 
        name: 'masters/society/locations/administrativecenters',
        params: { id: this.id, idSede: this.idSede } 
      })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idSociedad: this.id,
          idSede: this.idSede,
          idFaceB2BCentro: id
        }
        const res = await getAdministrativeCenterFB2B(params)
        this.setContact(res.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setContact: function (contact) {
      this.form.Code = contact.Code
      this.form.Name = contact.Name
      this.form.Role = contact.Role
    },
    updateView: function () {
      this.header.breadcrumb[4].name = this.form.Code
      this.$store.commit('app/setheaderBreadCrumb', this.form.Code)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
